module.exports = __webpack_public_path__ + "media/night/260-263a02ec.svg";